export default "__VITE_ASSET__ad621ecc__"